import { MeetingType } from 'server/types';
import { useIntl } from 'shared/intl/use-intl';

export function useMeetingType() {
  const intl = useIntl();
  const meetingTypes: Record<MeetingType, string> = {
    zoom: 'Zoom',
    external: intl('External'),
    presentation: intl('Presentation'),
    videoconference: intl('Video'),
    inperson: intl('In-Person'),
  };
  return meetingTypes;
}
